import { Flex, HStack } from '@chakra-ui/react';
import React from 'react';

import { MaskIcon } from '../MaskIcon';
import MobileSupportTooltip from '../MobileSupportTooltip';
import { Percent } from '../Num';
import { useH2SwapSlippageDialog } from './components/H2SwapSlippageDialog/useH2SwapSlippageDialog';

const H2SlippageTolerance = () => {
  const slippage = useH2SwapSlippageDialog((s) => s.entered);
  const openSlippageModal = useH2SwapSlippageDialog((s) => s.open);

  return (
    <HStack gap="4px">
      <Flex gap="4px" textStyle="body2" mr="auto">
        Slippage tolerance{' '}
        <MobileSupportTooltip
          content={
            'Your transaction will fail if the price changes more than the slippage.'
          }
          positioning={{ placement: 'bottom-end' }}
        >
          <MaskIcon icon="url(/masks/info.svg)" boxSize="16px" />
        </MobileSupportTooltip>
      </Flex>
      <Percent
        onClick={openSlippageModal}
        cursor="pointer"
        fontWeight="bold"
        textDecoration="underline"
        color="primary"
        value={slippage}
        decimalPlaces={2}
      />
    </HStack>
  );
};

export default H2SlippageTolerance;
